import React from 'react';
import { assest } from '../Assest/Assest';
import '../css/Testimonials.css'; // Import the CSS file

function Testimonials() {
  return (
    <div className="testimonials-container">
      <video
        src={assest.video1}
        controls
        className="testimonial-video"
        autoPlay
        loop
        muted
      ></video>
      <video
        src={assest.video2}
        controls
        className="testimonial-video"
        autoPlay
        loop
        muted
      ></video>
      <video
        src={assest.video3}
        controls
        className="testimonial-video"
        autoPlay
        loop
        muted
      ></video>
      <video
        src={assest.video4}
        controls
        className="testimonial-video"
        autoPlay
        loop
        muted
      ></video>
    </div>
  );
}

export default Testimonials;
